import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ActivityLog() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(20);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  useEffect(() => {
    api.get("/activity-log", { params: { page, per_page: perPage } }).then(({ data }) => {
      setItems(Array.isArray(data) ? data : data.items || []);
      setTotal(Array.isArray(data) ? data.length : data.total || 0);
      setPages(Array.isArray(data) ? 1 : data.pages || 1);
    });
  }, [page]);

  return (
    <div className="space-y-6" data-testid="activity-log-page">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Audit</div>
        <h1 className="font-serif text-4xl tracking-tighter mt-1 text-[#1A1A1A]">Activity log</h1>
      </div>
      <Card className="bg-white border-black/10">
        <CardContent className="p-0">
          {items.length === 0 ? (
            <div className="p-10 text-center text-sm text-zinc-500">No activity yet.</div>
          ) : (
            <ul className="divide-y divide-black/5">
              {items.map((a) => (
                <li key={a.id} className="p-4" data-testid={`activity-row-${a.id}`}>
                  <div className="text-sm">{a.details}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">
                    {a.user_name || "System"} · {new Date(a.created_at).toLocaleString()} · <span className="capitalize">{a.action.replace(/_/g, " ")}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>

      <div className="flex justify-between items-center">
        <div className="text-sm text-zinc-500">Showing {items.length ? (page - 1) * perPage + 1 : 0} - {(page - 1) * perPage + items.length} of {total}</div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
            <ChevronLeft size={16} />
          </Button>
          <span className="text-sm font-medium">Page {page} of {pages}</span>
          <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>
            <ChevronRight size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
}
